const images = {
  digiovi: require('../images/digiovi.png'),
  backgroundBlurred: require('../images/background.jpg'),
  backgroundDimmed: require('../images/bg_dimmed.jpg'),
  Ajax: require('../images/ajax-on.png'),
  AjaxOff: require('../images/ajax-off.png'),
  AuditLogs: require('../images/audit_logs-on.png'),
  AuditLogsOff: require('../images/audit_logs-off.png'),
  Monitoring: require('../images/monitoring-on.png'),
  MonitoringOff: require('../images/monitoring-off.png'),
  excel: require('../images/excel.png'),
  MobilePhoneWhite: require('../images/mobilePhoneWhite.png'),
  MobilePhoneBlue: require('../images/mobilePhoneBlue.png'),
  MobilePhoneDarkGrey: require('../images/mobilePhoneDarkGrey.png'),
  MobilePhoneDisabledGrey: require('../images/mobilePhoneDisabledGrey.png'),
  // Ajax devices
  DoorProtectBlack: require('../images/ajax/DoorProtect/black.png'),
  DoorProtectWhite: require('../images/ajax/DoorProtect/white.png'),
  FireProtectBlack: require('../images/ajax/FireProtect/black.png'),
  FireProtectWhite: require('../images/ajax/FireProtect/white.png'),
  HomeSirenBlack: require('../images/ajax/HomeSiren/black.png'),
  HomeSirenWhite: require('../images/ajax/HomeSiren/white.png'),
  HubBlack: require('../images/ajax/Hub/black.png'),
  HubWhite: require('../images/ajax/Hub/white.png'),
  KeypadBlack: require('../images/ajax/Keypad/black.png'),
  KeypadWhite: require('../images/ajax/Keypad/white.png'),
  LeaksProtectBlack: require('../images/ajax/LeaksProtect/black.png'),
  LeaksProtectWhite: require('../images/ajax/LeaksProtect/white.png'),
  MotionCamBlack: require('../images/ajax/MotionCam/black.png'),
  MotionCamWhite: require('../images/ajax/MotionCam/white.png'),
  MotionProtectBlack: require('../images/ajax/MotionProtect/black.png'),
  MotionProtectWhite: require('../images/ajax/MotionProtect/white.png'),
  SocketBlack: require('../images/ajax/Socket/black.png'),
  SocketWhite: require('../images/ajax/Socket/white.png'),
  WallSwitchBlack: require('../images/ajax/WallSwitch/black.png'),
};

export default images;
